var styles = {"mediaContainer":"media-wrapper--media-container","blob":"media-wrapper--blob","media":"media-wrapper--media","mediaVideo":"media-wrapper--media-video","picture":"media-wrapper--picture"};

export { styles as default };
//# sourceMappingURL=MediaWrapper.module.esm.js.map
